module.exports = __webpack_public_path__ + "img/thermometer.969c856c.svg";